import styled, {css} from 'styled-components'

export const StyledMailerSubtitle = styled.p(
    ({theme: {palette, typography}}) => css`
        ${typography.textSm};
        color: ${palette.neutral[600]};
        max-width: 760px;
    `
)

export const StyledMailerWrapper = styled.div(
    ({theme: {palette}}) => css`
        display: grid;
        grid-template-rows: auto auto minmax(0, 1fr);
        background-color: ${palette.neutral['white']};
        height: 100%;
        border-radius: 8px 8px 0 0;
        border: 1px solid ${palette.neutral[200]};
    `
)

export const StyledMailerViewport = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
    & > [hidden] {
        display: none;
    }
    & > div:not([hidden]) {
        display: flex;
        flex-direction: column;
        min-height: 0;
        flex: 1;
        overflow: hidden;
    }
`

export const StyledMailerFormContent = styled.div`
    overflow-y: auto;
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;
`

export const StyledMailerSection = styled.div(
    ({theme: {palette}}) => css`
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 16px;
        border: 1px solid ${palette.neutral[200]};
        border-radius: 8px;
    `
)

export const StyledMailerFooter = styled.div(
    ({theme: {palette}}) => css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 8px;
        padding: 16px 24px;
        border-top: 1px solid ${palette.neutral[200]};
    `
)

export const StyledMailerFooterGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`

export const StyledAttachmentsList = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`

export const StyledAttachmentChip = styled.div(
    ({theme: {palette}}) => css`
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 4px 8px;
        background-color: ${palette.neutral[50]};
        border: 1px solid ${palette.neutral[200]};
        border-radius: 6px;
        font-size: 13px;
        color: ${palette.neutral[700]};
    `
)

export const StyledAttachmentMeta = styled.span(
    ({theme: {palette}}) => css`
        font-size: 12px;
        color: ${palette.neutral[500]};
    `
)

export const StyledAttachmentSummary = styled.div(
    ({theme: {palette, spacing}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 1}px;
        margin-top: ${spacing * 2}px;
        font-size: 12px;
        color: ${palette.neutral[600]};
    `
)
